export enum DispatchOnEnoughBalanceResult {
  None = 'none',
  Success = 'success',
  BalanceTimeout = 'balanceTimeout',
  PartialDispatchError = 'partialDispatchError',
  TotalDispatchError = 'totalDispatchError'
}
